module.exports = __webpack_public_path__ + "img/culture.7ef1be62.jpg";